/**
 * @desc 启禁用
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateMemberEnableParameter = {
  memberId?: string
}

const method = 'PUT'
const url = '/auth/operation/member/enable'

export const updateMemberEnableApi = (
  params?: UpdateMemberEnableParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

updateMemberEnableApi.method = method
updateMemberEnableApi.url = url
